type DimensionAbbreviation =
  | 'BG'
  | 'BM'
  | 'CD'
  | 'EDS'
  | 'ELS'
  | 'FE'
  | 'FLD'
  | 'ILF'
  | 'LM'
  | 'NC'
  | 'PC'
  | 'PR'
  | 'QF'
  | 'RC'
  | 'RCP'
  | 'RSP'
  | 'TS';

interface Dimension {
  name: string;
  t_name: string;
  abbreviation: DimensionAbbreviation;
}

export const DIMENSIONS: Record<DimensionAbbreviation, Dimension> = {
  BG: {
    name: 'Behavior Guidance',
    abbreviation: 'BG',
    t_name: 'behavior_guidance'
  },
  BM: {
    name: 'Behavior Management',
    abbreviation: 'BM',
    t_name: 'behavior_management'
  },
  CD: {
    name: 'Concept Development',
    abbreviation: 'CD',
    t_name: 'concept_development'
  },
  EDS: {
    name: 'Educator Sensitivity',
    abbreviation: 'EDS',
    t_name: 'educator_sensitivity'
  },
  ELS: {
    name: 'Early Language Support',
    abbreviation: 'ELS',
    t_name: 'early_language_support'
  },
  FE: {
    name: 'Facilitated Exploration',
    abbreviation: 'FE',
    t_name: 'facilitated_exploration'
  },
  FLD: {
    name: 'Facilitation of Learning and Development',
    abbreviation: 'FLD',
    t_name: 'facilitation_of_learning_and_development'
  },
  ILF: {
    name: 'Instructional Learning Formats',
    abbreviation: 'ILF',
    t_name: 'instructional_learning_formats'
  },
  LM: {
    name: 'Language Modeling',
    abbreviation: 'LM',
    t_name: 'language_modeling'
  },
  NC: {
    name: 'Negative Climate',
    abbreviation: 'NC',
    t_name: 'negative_climate'
  },
  PC: {
    name: 'Positive Climate',
    abbreviation: 'PC',
    t_name: 'positive_climate'
  },
  PR: {
    name: 'Productivity',
    abbreviation: 'PR',
    t_name: 'productivity'
  },
  QF: {
    name: 'Quality of Feedback',
    abbreviation: 'QF',
    t_name: 'quality_of_feedback'
  },
  RC: {
    name: 'Relational Climate',
    abbreviation: 'RC',
    t_name: 'relational_climate'
  },
  RCP: {
    name: 'Regard for Child Perspectives',
    abbreviation: 'RCP',
    t_name: 'regard_for_child_perspectives'
  },
  RSP: {
    name: 'Regard for Student Perspectives',
    abbreviation: 'RSP',
    t_name: 'regard_for_student_perspectives'
  },
  TS: {
    name: 'Educator Sensitivity',
    abbreviation: 'TS',
    t_name: 'teacher_sensitivity'
  }
};
